import store from './store'

import { bogs } from '@/dbs'

async function loadTopRating () {
  const { rows: topRatingRows } = await bogs.query('bogs_top_rating', {
    reduce: true,
    group_level: 1
  })
  const ratings = topRatingRows[0].value
  // console.log({ ratings })
  const { rows: bogRows } = await bogs.allDocs({
    include_docs: true,
    keys: ratings.map(({ osm }) => `bog:${osm}:info`)
  })
  bogRows.forEach((row, index) => {
    row.rating = ratings[index]
  })
  // console.log({ bogRows })
  store.commit('SET_TOP_RATED', bogRows)
}

loadTopRating()
  .catch(e => console.error(e))
